/* eslint-disable max-len */
import React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const CircleOutline: React.FC<Props> = ({ ...props }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M10 2.75C14.0039 2.75 17.25 5.99608 17.25 10C17.25 14.0039 14.0039 17.25 10 17.25C5.99608 17.25 2.75 14.0039 2.75 10C2.75 5.99608 5.99608 2.75 10 2.75Z"
      stroke={props.color ?? props?.style?.color}
      strokeWidth="1.5"
    />
  </svg>
);

export default CircleOutline;
